module.exports = __webpack_public_path__ + "img/DSK.1acad071.png";